import { alpha, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  borderLeft: '4px solid',
  borderColor: theme.palette.error.main,
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  padding: theme.spacing(1.5),
  display: 'flex',
  '& .WEErrorItem': {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(16),
  },
  '& .WEErrorText': {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    fontFamily: theme.typography.fontFamilySecondary,
    color: theme.palette.common.white,
    paddingBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },
  '& .WECloseIcon': {
    color: theme.palette.common.white,
    alignSelf: 'end',
  },
}));

export default StyledBox;
